// InquiryListWrapper.tsx
import { useParams } from "react-router-dom";
import InquiryList from "./pages/InquiryList";

const InquiryListWrapper = () => {
  const { vertical } = useParams<{ vertical: string }>();
  return <InquiryList key={vertical} />;
};

export default InquiryListWrapper;
